import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
    errors?: Array<string>;
}
export interface GeneralResponseBody {
    data: Array<PolicyType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}

export interface PolicyType {
    id: string;
    code: string;
    name: string;
}

export const fetchPolicyTypes = createAction<fetchPolicyTypesAction>(
    ActionTypes.FETCH_POLICY_TYPES,
);
export const fetchPolicyTypesSuccess =
    createAction<fetchPolicyTypesSuccessAction>(
        ActionTypes.FETCH_POLICY_TYPES_SUCCESS,
    );
export const fetchPolicyTypesFailed =
    createAction<fetchPolicyTypesFailedAction>(
        ActionTypes.FETCH_POLICY_TYPES_FAILED,
    );
export const clearPolicyType = createAction<clearPolicyTypeAction>(
    ActionTypes.CLEAR_POLICY_TYPE,
);

export interface fetchPolicyTypesAction {
    type: typeof ActionTypes.FETCH_POLICY_TYPES;
    payload: null | undefined;
}

export interface fetchPolicyTypesSuccessAction {
    type: typeof ActionTypes.FETCH_POLICY_TYPES_SUCCESS;
    body: GeneralResponse;
}

export interface fetchPolicyTypesFailedAction {
    type: typeof ActionTypes.FETCH_POLICY_TYPES_FAILED;
    body: GeneralResponse;
}
export interface clearPolicyTypeAction {
    type: typeof ActionTypes.CLEAR_POLICY_TYPE;
    payload: undefined;
}
